import {get_token} from "@/router";
import Swal from 'sweetalert2';
import 'quill/dist/quill.snow.css';
import 'quill-mention';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
    components: {
      Multiselect,
    },
    data() {
        return ({
          token_exists: false,
          user_details: {
            "user_role": '',
            "user_id": '',
          },
          temporaryPost: null,
          isSubmitting: false,
          fileName:'',
          imagePreview: null,
          topics:[],
          created_by_id:this.created_by,
          portals:[],
          isMaster: false,
          selectedPortals: [],
          selectedMasterPortal: '',
          categories: [],
          selectedPortalId: null,
          selectedTopicId: null,
          selectedVisibility: 'public',
          searchQuery:"",
          errors: {
            voice_description:null,
            voice_name:null,
            audio_file :null,
            portal: null,
            segment: null,
            report_description: null
          },         
          upload_media: null,
          payload:{},
          location:null,
          incident_description:null,
          document_name: '',
          document_description: '',
          selected_reviewers: [],
          tempSelectedReviewer: [],
          reviewers: [],
        });
      },
 mounted() {
    this.fetchPortalMembers();
 }, 
 methods: {

    getToken() {
      return get_token();
    },    
    validateDocumentForm() {
        this.errors = {};

        if (!this.document_name.trim()) {
          this.errors.document_name = "Document name is required.";
        }

        return Object.keys(this.errors).length === 0;
      },
      
    fetchPortalMembers() {
    this.isLoading = true;
    $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_portal_members/`,
        method: "GET",
        data: { portal_id: this.$route.params.portal_id },
        headers: {
        "Authorization": `Token ${this.getToken()}`,
        "Content-Type": "application/json"
        },
        success: (response) => {

        if (response.status === "success") {
            this.reviewers = response.data.members;
        }
        },
        error: (xhr) => {
        if (xhr.status === 403) {
            this.$router.push("/");
            Swal.fire({
            icon: "error",
            title: "Access Denied",
            text: "You are not authorized to be in this portal.",
            showConfirmButton: false,
            timer: 3000
            });
        }
        },
        complete: () => {
        this.isLoading = false;
        }
    });
    },
    handleApprovalFileUpload(event) {
      const file = event.target.files[0];

      if (file) {
        if (file.type.startsWith("audio/")) {
          this.fileError = "Audio files are not allowed.";
          this.upload_media = null;
          this.fileName = "";
          this.imagePreview = null; // Reset preview if an invalid file is selected
          event.target.value = ""; // Clear file input
        } else {
          this.fileName = file.name;
          this.fileError = "";
          this.upload_media = file;

          // Check if the file is an image before previewing
          if (file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = (e) => {
              this.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
          } else {
            this.imagePreview = null; // Reset preview for non-image files
          }
        }
      } else {
        this.fileName = "";
        this.fileError = "";
        this.upload_media = null;
        this.imagePreview = null;
      }
    },
    createDocumentApproval() {
        if (!this.validateDocumentForm()) {
          return;
        }

        this.temporaryPost = {
          document_name: this.document_name,
          isTemp: true,
        };
        this.$emit('new_temp_post', this.temporaryPost);
        $('#document_approval_modal').modal('hide');

        this.$nextTick(() => {
          const tempPostElement = document.getElementById('temp-post');
          if (tempPostElement) {
            tempPostElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });


        this.isSubmitting = true;
        const formData = new FormData();
        formData.append("document_name", this.document_name);
        this.document_description = this.$refs.quillDocumentEditorRef.getHTML()
        formData.append("description", this.document_description);
        formData.append("portal_id", this.$route.params.portal_id);

        this.selected_reviewers = this.tempSelectedReviewer.map((reviewer) => reviewer.id);

        this.selected_reviewers.forEach((id) => {
          formData.append("reviewer", id);
        });

        const baseUrl = `${window.location.origin}${this.$route.path}`;
        const documentUrl = `${baseUrl}?portal_id=${this.portal_id}`;
        formData.append('base_url', documentUrl);
        if (this.upload_media) {
          formData.append('file', this.upload_media);
        }

        $.ajax({
          type: "POST",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/request_document_approval/`,
          data: formData,
          processData: false,
          contentType: false,
          headers: {
            Authorization: `Token ${this.getToken()}`,
          },
          success: (response) => {

            if (response.status === "success") {
              this.$emit("new_document", response.data);

              this.$nextTick(() => {
                const newPostElement = document.getElementById(`post-${response.data.id}`);
                if (newPostElement) {
                  newPostElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
              });

              this.temporaryPost = null;
            }
          },
          error: (response) => {
            Swal.close();
            const response_data = response.responseJSON;
            if (response_data.status === "error") {
              this.errors.document_name = response_data.message;
            }
          },
          complete: () => {
            this.isSubmitting = false;
          },
        });
      },

  
  }
}